import React, { ComponentType, useLayoutEffect } from "react"
import { ProductFragment } from "../../shopify/sdk"
import { Decay } from "./Interventions/Decay"
import { Carousel } from "../../components/Carousel"
import { useProduct } from "./useProduct"

const interventions: Record<string, ComponentType<ProductContentProps>> = {
  decay: Decay,
}

export type ProductContentProps = { product: ProductFragment }
const ProductContent = ({ product }: ProductContentProps) => {
  const backgroundColor = product.background_color?.value
  const intervention = product.intervention?.value

  const Intervention = intervention ? interventions[intervention] : null

  useLayoutEffect(() => {
    if (!backgroundColor) return
    document.documentElement.style.setProperty(
      "--background-color",
      backgroundColor
    )
    return () => {
      document.documentElement.style.setProperty("--background-color", null)
    }
  }, [backgroundColor])

  return (
    <>
      {Intervention && <Intervention product={product} />}
      {!Intervention && <Carousel product={product} />}
    </>
  )
}

export const Product = () => {
  const product = useProduct()
  if (product === null) return null
  return <ProductContent product={product} />
}
